import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import * as _ from 'lodash';

@Component({
  selector: 'mapfre-auditlib-progress',
  templateUrl: './progress.component.html',
  styleUrls: ['./progress.component.scss']
})
export class ProgressComponent implements OnInit {
  _value;

  get value() {
    return this._value;
  }

  @Input('value')
  set value(value) {
    if (!_.isNull(value)) {
      this._value = value;
    }
  }

  _max;

  get max() {
    return this._max;
  }

  @Input('max')
  set max(max) {
    if (!_.isNull(max)) {
      this._max = max;
    }
  }

  @Input()
  height = "4px";

  @Input()
  type = "default"

  constructor() { }

  ngOnInit() {
  }

}
